module.exports = __webpack_public_path__ + "static/media/Home_Icon6.32bef4c8.png";